// extracted by mini-css-extract-plugin
export default {"TeamFilters":"TeamFilters_TeamFilters__qHd3G","filterItem":"TeamFilters_filterItem__Agv3D","teamIcon":"TeamFilters_teamIcon__8VRsC","teamName":"TeamFilters_teamName__PQaoh"};